// 获取规格拼接需要的连接线数量
export const getSpecLineNumber = (e) => {
  // 传入的数量是string类型需要转换一下
  const str = '-'
  if (!e) return str
  const num = Number(e)
  return str.repeat(num)
}

// 获取规格参数拼接字符
export const getSpecificationTypeText = (arr, specKeys) => {
  console.log('specKeys', specKeys)
  let text = ''
  try {
    text = arr.reduce((prev, curr, index) => {
      if (index < arr.length - 1) {
        const specKeysItem = specKeys.find((it, itIndex) => index === itIndex)
        return prev + curr + getSpecLineNumber(specKeysItem.linenumber)
      }
      return prev + curr
    }, '')
  } catch (err) {
    text = ''
  }
  return text
}

// 处理输入框拼接规格名称和参数，规格名称、处理后获取的规格参数、原始规格参数、特殊字符数组
export const specialSpecInputValueText = (specName, specValue, originalSpecValue, specialCharacterList) => {
  if (originalSpecValue.includes('—')) {
    const splitArr = originalSpecValue.split('—')
    if (splitArr.length > 0) {
      return splitArr[splitArr.length - 1]
    }
  }
  // const specialCharacterList = ['Φ']
  const specialCharacter = specialCharacterList.reduce((pre, cur) => {
    if (originalSpecValue.includes(cur)) {
      return cur
    }
    return pre
  }, '')
  if (specialCharacter) {
    return specialCharacter + specValue
  }
  return specValue
}

// 处理输入框拼接规格名称和参数，处理后获取的规格参数、原始规格参数、特殊字符数组
export const specialSpecInputValue = (specValue, originalSpecValue, specialCharacterList) => {
  const specialCharacter = specialCharacterList.reduce((pre, cur) => {
    if (originalSpecValue.includes(cur)) {
      return cur
    }
    return pre
  }, '')
  if (specialCharacter) {
    if (specValue.includes(specialCharacter)) return specValue
    return specialCharacter + specValue
  }
  return specValue
}



// WEBPACK FOOTER //
// ./src/utils/fitLine.js